module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGd10c0fffc1f72e9c82ee6ad7f62ee84f.d10c0fff.png";